<script>
import { Line } from "vue-chartjs";
import chartjsPluginAnnotation from "chartjs-plugin-annotation";
import moment from "moment";

export default {
  extends: Line,
  props: ["chartdata", "max"],
  mounted() {
    function numberWithThousands(x) {
      var v = (x || "").toString();
      if (v.length >= 5) {
        return v.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        return v;
      }
    }

    function comma(x) {
      var v = x.toString();
      return v.replace(".", ",");
    }

    var options = {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: false,
      },
      annotation: {
        drawTime: "afterDatasetsDraw",
        annotations: [
          {
            type: "line",
            mode: "vertical",
            scaleID: "x-axis-0",
            value: "2020-12-25",
            borderColor: "rgba(0,0,0,.4)",
            borderWidth: 2,
            borderDash: [5, 5],
            label: {
              enabled: true,
              position: "top",
              content: "🎄",
              backgroundColor: "rgba(0,0,0,0)",
              fontColor: "#333",
              cornerRadius: 0,
            },
          },
          {
            type: "line",
            mode: "vertical",
            scaleID: "x-axis-0",
            value: "2020-12-25",
            borderColor: "rgba(0,0,0,0)",
            borderWidth: 0,
            label: {
              enabled: true,
              position: "top",
              content: "Natal",
              yAdjust: 14,
              backgroundColor: "rgba(0,0,0,0)",
              fontColor: "#333",
              cornerRadius: 0,
            },
          },
          {
            type: "line",
            mode: "vertical",
            scaleID: "x-axis-0",
            value: "2020-12-31",
            borderColor: "rgba(0,0,0,.4)",
            borderWidth: 2,
            borderDash: [5, 5],
            label: {
              enabled: true,
              position: "top",
              content: "🎉",
              yAdjust: 28,
              backgroundColor: "rgba(0,0,0,0)",
              fontColor: "#333",
              cornerRadius: 0,
            },
          },
          {
            type: "line",
            mode: "vertical",
            scaleID: "x-axis-0",
            value: "2020-12-31",
            borderColor: "rgba(0,0,0,0)",
            borderWidth: 0,
            label: {
              enabled: true,
              position: "top",
              content: "Ano Novo",
              yAdjust: 40,
              backgroundColor: "rgba(0,0,0,0)",
              fontColor: "#333",
              cornerRadius: 0,
            },
          },
        ],
      },
      legend: {
        display: false,
      },
      tooltips: {
        enabled: true,
        filter: function(tooltipItem) {
          return tooltipItem.datasetIndex === 0;
        },
        mode: "single",
        callbacks: {
          title: function(tooltipItem) {
            return moment(
              tooltipItem[0].xLabel + " 00:00",
              "YYYY-MM-DD HH:mm"
            ).format("D MMMM");
          },
          label: function(tooltipItem) {
            return (
              numberWithThousands(comma(tooltipItem.yLabel.toFixed(1))) +
              " casos por um milhão de habitantes"
            );
          },
        },
      },
      scales: {
        yAxes: [
          {
            gridLines: {
              drawBorder: false,
            },
            ticks: {
              maxTicksLimit: 6,
              beginAtZero: true,
              suggestedMax: this.max + 100,
            },
          },
        ],
        xAxes: [
          {
            offset: true,
            type: "time",
            time: {
              displayFormats: {
                day: "D MMM",
              },
              unit: "day",
            },
            ticks: {
              maxRotation: 0,
              autoSkip: true,
              maxTicksLimit: 1,
              fontStyle: "bold",
            },
            gridLines: {
              drawTicks: true,
              drawOnChartArea: false,
            },
          },
        ],
      },
    };

    this.addPlugin([chartjsPluginAnnotation]);
    this.renderChart(this.chartdata, options);
  },
};
</script>

<style></style>
